import { cache } from '@/container/apollo-client/cache';
import { QUERY_USER_ONLINE_STATUS } from '@/graphql/query.graphql';
import {
  useworkspaceAuthMeV2Query,
  useWorkspaceMembersOnlineManagementSubscription,
  WorkspaceMembersOnlineManagementSubscription,
} from '@/types/generated/graphql';
import { gql, OnDataOptions } from '@apollo/client';
import { cacheOnly } from '@shared/constants';

const WORKSPACE_MEMBER_FRAGMENT = gql`
  fragment WORKSPACEMEMBER on WorkspaceMembers {
    userOnlineManagement
  }
`;

const SINGLE_MEMBER_FRAGMENT = gql`
  fragment SINGLEMEMBER on UserWorkspace {
    userOnlineManagement
  }
`;
export function useOnlineOfflineManagementSubscription() {
  useWorkspaceMembersOnlineManagementSubscription({
    onData,
  });
  const { data: authMeWorkspaceData } = useworkspaceAuthMeV2Query(cacheOnly);
  const { currentUserWorkspace } = authMeWorkspaceData?.workspaceAuthMeV2?.data || {};
  function onData({ data }: OnDataOptions<WorkspaceMembersOnlineManagementSubscription>) {
    const { userWorkspace, activeStatus, awayTill, icon, isActive, lastSeenAt, message } =
      data.data?.workspaceMembersOnlineManagement || {};

    if (currentUserWorkspace?.id === userWorkspace?.id) {
      cache.writeQuery({
        query: QUERY_USER_ONLINE_STATUS,
        variables: { userWorkspaceId: userWorkspace?.id },
        data: {
          getUserOnlineStatus: {
            __typename: 'UserOnlineManagementResponse',
            data: {
              __typename: 'UserActiveStatus',
              activeStatus,
              awaySet: null,
              awayTill,
              message,
              icon,
            },
          },
        },
      });
    }
    cache.writeFragment({
      id: 'WorkspaceMembers:' + userWorkspace?.id,
      fragment: WORKSPACE_MEMBER_FRAGMENT,
      data: {
        userOnlineManagement: {
          activeStatus,
          awayTill,
          icon,
          isActive,
          lastSeenAt,
          message,
        },
      },
    });

    cache.writeFragment({
      id: 'UserWorkspace:' + userWorkspace?.id,
      fragment: SINGLE_MEMBER_FRAGMENT,
      data: {
        userOnlineManagement: {
          activeStatus,
          awayTill,
          icon,
          isActive,
          lastSeenAt,
          message,
        },
      },
    });
  }
}
